import React, { useRef, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import { GetCargoRateInquiryV3, updatePricingInquiry, updateAlert } from '../../store/common/common_action'
import Modal from '../common/modal'
import LineInput from '../common/lineinput'
import * as iid from '../common/bookingElementId'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import Paper from '@mui/material/Paper'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import DropDownOA from '../common/dropDownOA'
import { Item } from '../common/snippets'
import { Stack } from '@mui/material'
import { updateModal } from '../../store/common/common_action'
import { urls } from '../common/constants'
import { focusElemnt, navigation1, navigation2 } from '../common/helper'
import { GetRequestCachedV3 } from '../common/api'
import { useTranslation } from '../../i18n/I18nProvider'
import { getPricingRateLabel } from './inquiryConstants'

const PricingInquiry = (props) => {
  const { translations } = useTranslation()
  const iq = translations?.inquiry || {}
  const cs = translations?.common || {}
  const { data, GetCargoRateInquiryV3, updatePricingInquiry } = {
    ...props,
  }
  const { common } = data
  const { loginData, cnsgnmntTypes, cityList, pricingInquiry } = { ...common }
  const [fromCity, setFromCity] = useState()
  const [toCity, setToCity] = useState()
  const [consignment, setConsignment] = useState()
  const [weightDcm, setWeightDcm] = useState(0)
  const [ETADays,setETADays] = useState(cs.NA || 'NA')

  const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }
  const prevcityList = usePrevious(cityList)
  const handleGetDetails = () => {
    const obj = {
      intCompanyID: loginData.intCompanyID,
      intFromCityID: fromCity.CityID,
      intToCityID: toCity.CityID,
      intConsignmentID: consignment.ConsignmentSubTypeID,
      dcmActWeight: weightDcm,
    }
    const data = {
      FromCityID: fromCity.CityID,
      ToCityID: toCity.CityID,
    }
    GetRequestCachedV3(urls.GetCityDistance, data, true, 24 * 60 * 60 * 1000)
      .then((res) => {
        if (res.status === 'Success') {
          const { Data: { Table: [{ Distance = 0 } = {}] = [] } = {} } = res || {}
          let distanceValue = Number(Distance) || 0;
          const result = distanceValue > 0 ? Math.ceil(distanceValue / 400) : (cs.NA || 'NA');
          setETADays(result)
          GetCargoRateInquiryV3(obj,distanceValue)
        } else {
          setETADays(cs.NA || 'NA')
          GetCargoRateInquiryV3(obj,0)
        }
      })
      .catch((e) => {
        console.log(e)
      })
    focusElemnt(`closeButton`)
  }
  const handleSwapCity = () => {
    const temp = fromCity
    setFromCity(toCity)
    setToCity(temp)
    updatePricingInquiry([])
  }
  const handleOnClose = () => {
    updatePricingInquiry([])
    props.updateModal()
  }
  return (
    <>
      <Modal closeId="closeSearchPopup" headTxt={iq.pricingInquiryTitle || 'Pricing Inquiry - Get Rates & Transit Days '} width={'70%'} updateModal={handleOnClose}>
        <Stack sx={{ minHeight: 100, minWidth: 650, marginTop: '8px' }}>
          <Box
            key={`for_otp_lnIp_`}
            sx={{
              width: '100%',
              display: 'inline-flex',
              paddingLeft: '4px',
              paddingRight: '6px',
              borderBottom: '1px solid lightGray',
            }}
          >
            <Item sx={{ width: '27%' }}>
              <DropDownOA
                data={cityList.filter(({ CityID }) => toCity?.CityID != CityID) || []}
                width="100%"
                searchPlaceholder={iq.selectSourceCity || 'Select Source City'}
                label={iq.selectSourceCity || 'Select Source City'}
                tabIndex="4"
                value={fromCity?.CityName}
                isObjArr={true}
                dataKey={`CityName`}
                idKey={`CityID`}
                id={`sourceCity`}
                onSelect={(e) => {
                  setFromCity(e)
                }}
                autoFocus={true}
                nextId={`destCity`}
              />
            </Item>
            <SwapHorizIcon style={{ color: 'gray', fontSize: '30', marginTop: '10px' }} onClick={handleSwapCity} />
            <Item sx={{ width: '28%' }}>
              <DropDownOA
                label={iq.selectDestinationCity || 'Select Destination City'}
                data={cityList.filter(({ CityID }) => fromCity?.CityID != CityID)}
                width="100%"
                value={toCity?.CityName}
                searchPlaceholder={iq.searchDestinationCity || 'Search Destination City'}
                isObjArr={true}
                dataKey={`CityName`}
                idKey={`CityID`}
                id={`destCity`}
                tabIndex="4"
                onSelect={(e) => {
                  setToCity(e)
                }}
                nextId={`consignmentType`}
                prevId={`sourceCity`}
              />
            </Item>
            <Item sx={{ width: '25%' }}>
              <DropDownOA
                id={`consignmentType`}
                data={cnsgnmntTypes || []}
                width="100%"
                searchPlaceholder={iq.searchConsignmentType || 'Search Consignment Type'}
                label={iq.selectConsignment || 'Select Consignment'}
                isObjArr={true}
                dataKey={`SubType`}
                idKey={`ConsignmentSubTypeID`}
                onSelect={(e) => {
                  setConsignment(e)
                }}
                nextId={consignment?.IsKgKm ? `actualWeight` : `getDetailButton`}
                prevId={`destCity`}
              />
            </Item>
            <Item sx={{ width: '15%' }}>
              <div className={'input--wrapper'} style={{ marginBottom: '0px' }}>
                <LineInput
                  id={`actualWeight`}
                  type="text"
                  name="Actual Weight"
                  label={iq.actualWeight || 'Actual Weight'}
                  value={weightDcm}
                  disabled={consignment?.IsKgKm ? false : true}
                  onChange={(e) => setWeightDcm(e.target.value)}
                  onKeyDown={(e) => navigation1(e, `getDetailButton`, `consignmentType`)}
                />
              </div>
            </Item>
            <div
              className="input--wrapper small_space"
              style={{
                width: '15%',
                paddingLeft: '0px',
                paddingRight: '0px',
                paddingTop: '8px',
                paddingBottom: '8px',
              }}
            >
              <Button
                id={`getDetailButton`}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem' }}
                onClick={handleGetDetails}
              >
                {iq.getDetails || 'GET DETAILS'}
              </Button>
            </div>
          </Box>
          <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
            <TableContainer
              className="lr-popup-table lrModel"
              component={Paper}
              style={{
                height: '200px',
                marginTop: '10px',
                borderBottom: '1px solid lightGray',
              }}
            >
              <Table className="table1" size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                  <TableRow style={{ background: `#e5f3fa`, height: '45px' }}>
                    <TableCell style={{ fontSize: '13px' }}>{iq.serviceType || 'Service Type'}</TableCell>
                    <TableCell style={{ fontSize: '13px' }}>{iq.byBus || 'By Bus'}</TableCell>
                    <TableCell style={{ fontSize: '13px' }}>{iq.byCargo || 'By Cargo'}</TableCell>
                    <TableCell style={{ fontSize: '13px' }}>{iq.byExpressCargo || 'By Express Cargo'}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="filter-data-row">
                  {pricingInquiry?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ paddingTop: '12px', paddingBottom: '12px', borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }}>
                          {getPricingRateLabel(consignment, translations)}
                        </span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }}>{cs.NA || 'NA'}</span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }} title={item.NormalRate}>
                          {item.NormalRate}
                        </span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }} title={item.ExpressRate}>
                          {item.ExpressRate}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                  {pricingInquiry?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ paddingTop: '12px', paddingBottom: '12px', borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }}>{iq.transitDays || 'Transit Days'}</span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }}>{ETADays}</span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }} title={ETADays}>
                          {ETADays}
                        </span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }} title={ETADays}>
                          {ETADays}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                  {pricingInquiry?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ paddingTop: '12px', paddingBottom: '12px', borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }}>{iq.crossingStation || 'Crossing Station'}</span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }}>{cs.NA || 'NA'}</span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }} title={item.CrossingCityNames}>
                          {item.CrossingCityNames === '' ? (iq.noCrossing || 'No Crossing') : item.CrossingCityNames}
                        </span>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <span style={{ fontSize: '13px' }} title={item.CrossingCityNames}>
                          {item.CrossingCityNames === '' ? (iq.noCrossing || 'No Crossing') : item.CrossingCityNames}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Stack>
        <Stack>
          <div className="input--wrapper small_space" style={{ textAlign: 'end', marginBottom: '0px' }}>
            <Button
              id={`closeButton`}
              className="select-lr-btn"
              variant="contained"
              color="error"
              style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', borderColor: 'white', margin: '15px' }}
              onClick={handleOnClose}
            >
              {cs.close || 'Close'}
            </Button>
          </div>
        </Stack>
      </Modal>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, GetCargoRateInquiryV3, updatePricingInquiry }
export default connect(mapStateToProps, mapDispatchToProps)(PricingInquiry)
